import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Badge } from "react-bootstrap";

const BubbleWithNumber = ({ number, color }) => {
  // Convert the number to a string to calculate its length
  const numberString = number && number.toString();
  const length = numberString && numberString.length;

  // Dynamically set styles based on length
  const width = length <= 2 ? 20 : length * 10; // Wider for 3+ digits
  const borderRadius = length <= 2 ? "50%" : "10px"; // Circle for 1-2 digits, rounded for more

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      {number > 0 && (
        <span
          style={{
            position: "absolute",
            top: "-17px",
            right: "-1px",
            backgroundColor: color,
            color: "white",
            borderRadius: borderRadius,
            padding: "5px",
            fontSize: "12px",
            width: `${width}px`, // Dynamic width
            height: "20px", // Fixed height
            display: "flex",
            alignItems: "center",
            justifyContent: "center", // Center the number
          }}
        >
          {number}
        </span>
      )}
    </div>
  );
};

export default BubbleWithNumber;
//
